<template>
  <div>
    <div>
      <div class="head-topbar lite-page-top linebottom sticky">
        <div class="topbar-left" @click="goto('/jnt/center/setting')">
          <i class="icon-arrow-left"></i>
        </div>
        <div class="topbar-main"><h4>服务协议</h4></div>
      </div>
      <div class="agreementPage">
        <div class="content">
          <p></p>
          <p style="text-align: center;">
            <strong><span style="font-size: 14pt;">嘉盛云平台用户协议</span></strong>
          </p>
          <p>欢迎使用嘉盛云平台提供的服务。请您（下列统称为“用户”）仔细阅读以下全部内容。</p>
          <p><strong>1.服务条款的确认和接纳</strong></p>
          <p>
            嘉盛云平台服务涉及到的产品的所有权以及相关软件的知识产权归嘉盛云平台所有。嘉盛云平台所提供的服务必须按照其发布的公司章程，服务条款和操作规则严格执行。本服务条款的效力范围及于将嘉盛云平台手机帐号作为登录帐号的嘉盛云平台产品和服务（以下简称“嘉盛云平台各单项服务”），用户在享受嘉盛云平台各单项服务时，应当受本服务条款的约束。
          </p>
          <p>
            当用户使用嘉盛云平台各单项服务时，用户同意以单项服务要求的方式同意该单项服务的服务条款以及嘉盛云平台在该单项服务中发出的各类公告（下列简称为“单项条款”），在此情况下单项条款与本服务条款同时对用户产生效力。若单项条款与本服务条款存在同类条款的冲突，则在单项条款约束范围内应以单项条款为准。
          </p>
          <p><strong>2.嘉盛云平台手机帐号服务简介</strong></p>
          <p>
            本服务条款所称的“嘉盛云平台手机帐号”是指用户以手机号码作为帐号注册的合法、有效的帐号，嘉盛云平台手机帐号注册成功后帐号即为手机号。
          </p>
          <p>嘉盛云平台公司运用自己的操作系统通过国际互联网络为用户提供各项服务。用户必须：</p>
          <p>（1）提供设备，如个人电脑、手机或其他上网设备。</p>
          <p>（2）个人上网和支付与此服务有关的费用。</p>
          <p><strong>3.嘉盛云平台手机帐号注册规则</strong></p>
          <p>
            用户确认，在注册或使用嘉盛云平台服务时，应当具备中华人民共和国法律规定的与其行为相适应的民事行为能力，确保有能力对所使用嘉盛云平台服务的一切行为独立承担责任。若用户不具备前述主体资格，请在父母或其他监护人（以下简称“监护人”）的陪同下阅读本服务条款，并在取得监护人对使用嘉盛云平台服务的行为及对本服务条款的同意之后，方可注册并使用嘉盛云平台服务；嘉盛云平台在依据法律规定或本服务条款要求用户承担责任时，有权向其监护人追偿。
          </p>
          <p>
            此外，用户还需确保其不是任何国家、国际组织或者地域实施的贸易限制、制裁或其他法律、规则限制的对象，也未直接或间接为前述对象提供资金、商品或服务，否则应当停止注册或使用嘉盛云平台服务，同时用户理解违反前述要求可能会造成其无法正常注册及使用嘉盛云平台服务。
          </p>
          <p>
            嘉盛云平台手机帐号注册资料包括但不限于：用户的手机号码、密码及注册嘉盛云平台手机帐号或更新嘉盛云平台手机帐号注册资料时输入的所有信息或更新嘉盛云平台手机帐号时输入的所有信息以及用户使用嘉盛云平台各单项服务时输入的名称、头像等所有信息。
          </p>
          <p>
            用户在注册嘉盛云平台手机帐号时承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线，不得在嘉盛云平台手机帐号注册资料中出现违法和不良信息，且用户保证其在注册和使用帐号时，不得有以下情形：
          </p>
          <p>（1）违反宪法或法律法规规定的；</p>
          <p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
          <p>（3）损害国家荣誉和利益的，损害公共利益的；</p>
          <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
          <p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
          <p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
          <p>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
          <p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
          <p>（9）含有法律、行政法规禁止的其他内容的。</p>
          <p>
            若用户提供给嘉盛云平台的帐号注册资料不准确，不真实，含有违法或不良信息的，嘉盛云平台有权不予注册，并保留终止用户使用嘉盛云平台各项服务的权利。若用户以虚假信息骗取帐号注册或帐号头像、个人简介等注册资料存在违法和不良信息的，嘉盛云平台有权采取通知限期改正、暂停使用、注销登记等措施。对于冒用关联机构或社会名人注册帐号名称的，嘉盛云平台有权注销该帐号，并向政府主管部门进行报告。
          </p>
          <p>根据相关法律、法规规定以及考虑到嘉盛云平台产品服务的重要性，用户同意：</p>
          <p>（1）提供及时、详尽及准确的帐户注册资料；</p>
          <p>
            （2）用户同意，其提供的真实、准确、合法的嘉盛云平台手机帐号注册资料作为认定用户与其嘉盛云平台手机帐号的关联性以及用户身份的唯一证据。用户在享用嘉盛云平台各项服务的同时，同意接受嘉盛云平台提供的各类信息服务。嘉盛云平台提醒用户，为使用户及时、全面了解嘉盛云平台提供的各项服务，用户同意，嘉盛云平台可以多次、长期向用户发送各类商业性短信息而无需另行获得用户的同意。
          </p>
          <p>
            在法律法规允许的范围内，用户同意嘉盛云平台邮箱账号所有权，以及与注册、使用嘉盛云平台手机帐号相关的服务数据和记录，包括但不限于所有注册、登录、消费记录和相关的使用统计数据，归嘉盛云平台所有。发生争议时，用户同意以嘉盛云平台的系统数据为准，嘉盛云平台保证该数据的真实性。
          </p>
          <p>
            尽管有前述约定，在法律法规允许的范围内，对于用户使用嘉盛云平台手机帐号享受嘉盛云平台旗下的各项服务时产生的服务数据和记录，包括但不限于产品登录记录、消费记录及其他产品日志、产品客户服务记录，归具体产品运营主体所有。发生争议时，用户同意以具体产品运营主体的系统数据为准。但是如果单项条款存在与前述不同的约定，则以单项条款约定为准。
          </p>
          <p><strong>4.服务条款的修改</strong></p>
          <p>
            嘉盛云平台有权在必要时通过在网页上发出公告等合理方式修改本服务条款以及各单项服务的相关条款。用户在享受各项服务时，应当及时查阅了解修改的内容，并自觉遵守本服务条款以及该单项服务的相关条款。用户如继续使用本服务条款涉及的服务，则视为对修改内容的同意，当发生有关争议时，以最新的服务条款为准；用户在不同意修改内容的情况下，有权停止使用本服务条款涉及的服务。
          </p>
          <p><strong>5.服务的变更或中止</strong></p>
          <p>
            嘉盛云平台始终在不断变更和改进服务。嘉盛云平台可能会增加或删除功能，也可能暂停或彻底停止某项服务。用户同意嘉盛云平台根据自身商业决策等原因可能会选择终止嘉盛云平台手机账号服务。如有此等情形发生，嘉盛云平台会采取公告的形式通知用户，除法律有明确规定的情况外，嘉盛云平台账号有权不经用户申请并直接为其办理退款。经国家行政或司法机关的生效法律文书确认用户存在违法或侵权行为，或者嘉盛云平台根据自身的判断，认为用户的行为涉嫌违反本协议内容或嘉盛云平台不时公布的使用规则等内容，或涉嫌违反法律法规的规定的，则嘉盛云平台账号有权中止、中断或终止向用户提供服务，并不承担任何责任。
          </p>
          <p><strong>6.用户隐私制度</strong></p>
          <p>
            嘉盛云平台（以下或称“我们”）注重保护用户个人信息及个人隐私。本隐私政策解释了用户个人信息收集和使用的有关情况，本隐私政策适用于嘉盛云平台向您提供的所有相关服务。如果您不同意本隐私政策的任何内容，您应立即停止使用嘉盛云平台服务。当您使用嘉盛云平台提供的任一服务时，即表示您已同意我们按照本隐私政策来合法使用和保护您的个人信息。
          </p>
          <p><strong>7.不可抗力条款</strong></p>
          <p>
            嘉盛云平台对不可抗力导致的损失不承担责任。本服务条款所指不可抗力包括：天灾、法律法规或政府指令的变更，因网络服务特性而特有的原因，例如境内外基础电信运营商的故障、计算机或互联网相关技术缺陷、互联网覆盖范围限制、计算机病毒、黑客攻击等因素，及其他合法范围内的不能预见、不能避免并不能克服的客观情况。
          </p>
          <p><strong>8.禁止服务的商业化</strong></p>
          <p>
            用户承诺，非经嘉盛云平台同意，用户不能利用嘉盛云平台各项服务进行销售或其他商业用途。如用户有需要将服务用于商业用途，应书面通知嘉盛云平台并获得嘉盛云平台的明确授权。
          </p>
          <p><strong>9.用户管理</strong></p>
          <p>
            用户独立承担其发布内容的责任。用户对服务的使用必须遵守所有适用于服务的地方法律、国家法律和国际法律。用户承诺：
          </p>
          <p>
            （1）用户在嘉盛云平台上发布信息或者利用嘉盛云平台的服务时必须符合中国有关法规，不得在嘉盛云平台的网页上或者利用嘉盛云平台的服务制作、复制、发布、传播以下信息：
          </p>
          <p>(a) 违反宪法确定的基本原则的；</p>
          <p>(b) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
          <p>(c) 损害国家荣誉和利益的；</p>
          <p>(d) 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
          <p>(e) 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
          <p>(f) 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
          <p>(g) 散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
          <p>(h) 侮辱或者诽谤他人，侵害他人合法权益的；</p>
          <p>(i) 煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</p>
          <p>(j) 以非法民间组织名义活动的；</p>
          <p>(k) 含有法律、行政法规禁止的其他内容的。</p>
          <p>
            （2）用户在嘉盛云平台的网页上发布信息或者利用嘉盛云平台的服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。用户需遵守法律法规的规定使用嘉盛云平台的服务。
          </p>
          <p>（3）用户不得利用嘉盛云平台的服务从事以下活动：</p>
          <p>(a) 未经允许，进入计算机信息网络或者使用计算机信息网络资源的；</p>
          <p>(b) 未经允许，对计算机信息网络功能进行删除、修改或者增加的；</p>
          <p>
            (c)
            未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；
          </p>
          <p>(d) 故意制作、传播计算机病毒等破坏性程序的；</p>
          <p>(e) 其他危害计算机信息网络安全的行为。</p>
          <p>（4）用户不得以任何方式干扰嘉盛云平台的服务。</p>
          <p>
            （5）用户不得滥用嘉盛云平台服务，包括但不限于：利用嘉盛云平台服务进行侵害他人知识产权或者合法利益的其他行为。
          </p>
          <p>（6）用户应遵守嘉盛云平台的所有其他规定和程序。</p>
          <p>
            用户须对自己在使用嘉盛云平台服务过程中的行为承担法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在嘉盛云平台首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，用户应给予嘉盛云平台等额的赔偿。若用户违反以上规定，嘉盛云平台有权作出独立判断立即暂停或终止对用户提供部分或全部服务，包括冻结、取消用户服务帐号等措施。用户理解，如果嘉盛云平台发现其网站传输的信息明显属于上段第(1)条所列内容之一，依据中国法律，嘉盛云平台有义务立即停止传输，保存有关记录，向国家有关机关报告，并且删除含有该内容的地址、目录或关闭服务器。
            (1)条所列内容之一，依据中国法律，嘉盛云平台有义务立即停止传输，保存有关记录，向国家有关机关报告，并且删除含有该内容的地址、目录或关闭服务器。
          </p>
          <p><strong>10.保障</strong></p>
          <p>
            用户同意保障和维护嘉盛云平台全体成员的利益，承担由用户违反服务条款的损害补偿费用，其它人使用用户的电脑、手机、帐号而产生的费用。用户或者使用用户帐号的其他人在进行祭祀过程中侵犯第三方知识产权及其他权利而导致被侵权人索赔的，由用户承担责任。
          </p>
          <p>
            如用户或其它网络服务提供者利用嘉盛云平台的服务侵害他人民事权益的，应当承担侵权等法律责任。
          </p>
          <p>
            如用户利用嘉盛云平台的服务实施侵权行为的，被侵权人有权通知嘉盛云平台采取删除、屏蔽、断开链接等必要措施。嘉盛云平台接到通知后，因自身过错若未及时采取必要措施的，按法律规定承担责任。
          </p>
          <p><strong>11.通知</strong></p>
          <p>
            所有发给用户的通知都可通过电子邮件、常规的信件或在网站显著位置公告的方式进行传送。嘉盛云平台将通过上述方法之一将消息传递给用户，告知他们服务条款的修改、服务变更、或其它重要事情。
          </p>
          <p><strong>12.内容、商标的所有权</strong></p>
          <p>
            嘉盛云平台提供的内容包括但不限于：非用户上传/提供的文字、软件、声音、相片、视频等。所有这些内容均属于嘉盛云平台，并受版权、商标、专利和其它财产所有权法律的保护。所以，用户只能在嘉盛云平台授权下才能使用这些内容，而不能擅自复制、再造这些内容、或创造与内容有关的派生产品。
          </p>
          <p><strong>13.法律</strong></p>
          <p>本条款适用中华人民共和国的法律，并且排除一切冲突法规的适用。</p>
          <p>
            如使用本条款项下服务中出现纠纷的，用户与嘉盛云平台应友好协商解决，若协商不成，用户同意将纠纷提交中国国际经济贸易仲裁委员会仲裁解决，并由3名仲裁员进行审理。仲裁裁决是终局的，对双方均有约束力。若单项条款与本服务条款在管辖约定内容上存在冲突，则在单项条款约束范围内应以单项条款为准。
          </p>
          <p><strong>14.信息储存及相关知识产权</strong></p>
          <p>
            嘉盛云平台对嘉盛云平台手机帐号上所有服务将尽力维护其安全性及方便性，但对服务中出现的信息（包括但不限于用户发布的信息）删除或储存失败不承担任何责任。另外嘉盛云平台有权判定用户的行为是否符合本服务条款的要求，如果用户违背了本服务条款的规定，嘉盛云平台有权中止或者终止对其嘉盛云平台手机帐号的服务。
          </p>
          <p>嘉盛云平台尊重知识产权并注重保护用户享有的各项权利。</p>
          <p><strong>15.其他</strong></p>
          <p>
            （1）嘉盛云平台不行使、未能及时行使或者未充分行使本条款或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响嘉盛云平台在将来行使该权利。
          </p>
          <p>
            （2）如本条款中的任何条款无论因何种原因完全或部分无效或不具有执行力，本服务条款的其余条款仍应有效且具有约束力，嘉盛云平台及用户均应尽力使该条款设定的本意得到实现。
          </p>
          <p>如用户对本条款内容有任何疑问，可拨打客服电话：0546-75889977进行咨询</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'agreement',
  data() {
    return {}
  },
  methods: {
    goto(str) {
      this.$router.push({ path: str })
    },
  },
  created() {},
  watch: {},
}
</script>

<style>
.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}
.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../../assets/jnt/zjt1.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}

.agreementPage {
  padding: 20px 15px;
}

.agreementPage .title {
  color: #333;
  font-size: 1.4rem;
}
.agreementPage .content {
  border-radius: 10px;
  background: #fff;
  padding: 10px;
  margin-top: 10px;
  font-size: 1.3rem;
  line-height: 2.2rem;
}
.weui-cells {
  margin-top: 1.17647059em;
  background-color: #fff;
  line-height: 1.41176471;
  font-size: 17px;
  overflow: hidden;
  position: relative;
}
.weui-cell {
  padding: 15px;
  position: relative;
  display: flex;
  align-items: center;
}
.weui-cell__bd {
  flex: 1;
}
.text-center {
  text-align: center;
}
.weui-cells:after,
.weui-cells:before {
  content: ' ';
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  color: #e5e5e5;
}
.weui-cells:before {
  top: 0;
  border-top: 1px solid #e5e5e5;
  transform-origin: 0 0;
  transform: scaleY(0.5);
}
.weui-cells:after {
  bottom: 0;
  transform-origin: 0 100%;
  transform: scaleY(0.5);
}
.weui-cells:after,
.weui-cells:before {
  content: ' ';
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  color: #e5e5e5;
}
.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.dashedlinebottom,
.dashedlinetop,
.linebottom,
.lineright,
.linetop {
  position: relative;
  -webkit-box-sizing: border-box;
  padding: 0;
}
.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}

.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../../assets/jnt/left1.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}
.head-topbar .topbar-right {
  padding-right: 1rem;
  position: absolute;
  right: 0.265rem;
  font-size: 1.272rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
